export enum Severity {
	OFF = 0,
	WARN = 1,
	ERROR = 2,
}
